import { ThemeKey } from "@smartsheet/design-tokens";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";

export const isUrsa = (themeMode: ThemeKey | RequiredThemeKeys) => {
    return themeMode.startsWith("ursa");
};

export const isLight = (themeMode: ThemeKey | RequiredThemeKeys) => {
    return themeMode.endsWith("light");
};
